<template>
  <div class="fade-in">
    <div v-if="loading" class="loading-container">
      <RotateSquare class="loading-position fade-in" size="60px"></RotateSquare>
    </div>
    <form v-else class="d-flex flex-column" @submit="validateForm">
      <div class="card flex-grow-1">
        <div class="card-header align-items-center">
          <strong>{{ $t("sectionPagamento.pagamentoNovoTitle") }} </strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="form-group ml-3">
              <small> {{ $t("textObrigatorios") }} </small>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <div class="form-group">
                <label for="NomeEmpresa"
                  >* {{ $t("sectionPagamento.pagamentoNomeEmpresa") }}</label
                >
                <input
                  id="NomeEmpresa"
                  v-model="configuracaoPagamento.nomeEmpresa"
                  class="form-control"
                  placeholder="digite o nome da empresa"
                  required
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <div class="form-group">
                <label for="Cnpj"
                  >* {{ $t("sectionPagamento.pagamentoCNPJ") }}</label
                >
                <input
                  id="Cnpj"
                  v-model="configuracaoPagamento.cnpjEmpresa"
                  class="form-control"
                  placeholder="digite o Cnpj da empresa"
                  required
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <div class="form-group">
                <label for="Usuario"
                  >* {{ $t("sectionPagamento.pagamentoUsuario") }}</label
                >
                <input
                  id="Usuario"
                  v-model="configuracaoPagamento.usuario"
                  class="form-control"
                  placeholder="digite seu usuário"
                  required
                  type="text"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <div class="form-group">
                <label for="Senha"
                  >* {{ $t("sectionUsuario.usuarioSenha") }}</label
                >
                <input
                  id="Senha"
                  v-model="configuracaoPagamento.senha"
                  class="form-control"
                  placeholder="digite sua senha"
                  required
                  type="password"
                />
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <div class="form-group">
                <label for="">Integradora Id</label>
                <input
                  class="form-control"
                  placeholder="digite o id da integradora"
                  required
                  type="text"
                />
              </div>
            </div> -->
            <div
              class="col-sm-12 col-md-6 col-lg-5 col-xl-4"
              title="Selecione uma integradora"
            >
              <div class="form-group">
                <label for="Integradora"
                  >* {{ $t("sectionPagamento.pagamentoIntegradora") }}</label
                >
                <v-select
                  id="Integradora"
                  v-model="integradorSelect.itemSelected"
                  :placeholder="$t('textSelecione')"
                  :options="integradorSelect.options"
                  :multiple="false"
                >
                  <template slot="no-options">
                    {{ $t("textNenhumResultado") }}
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <div class="form-group">
                <label for>{{
                  $t("sectionPagamento.pagamentoSafeCheckout")
                }}</label>
                <b-form-checkbox
                  v-model="configuracaoPagamento.safeCheckout"
                  name="check-button"
                  switch
                >
                  {{ $t("textYes") }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button class="btn btn-success mr-2" type="submit">
          {{ $t("btSalvar") }}
        </button>
        <button
          class="btn btn-secondary"
          type="reset"
          @click="$router.push('/configuracao-pagamento')"
        >
          {{ $t("btVoltar") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
export default {
  components: {
    RotateSquare
  },
  data() {
    return {
      integradorSelect: {
        itemSelected: "",
        options: []
      },
      loading: false,
      configuracaoPagamento: {
        id: "",
        contaId: "",
        integradoraPagamentoId: "",
        usuario: "",
        senha: "",
        nomeEmpresa: "",
        cnpjEmpresa: "",
        safeCheckout: false
      }
    };
  },
  created() {
    this.obterConfiguracaoPagamento(this.$route.params.id);
  },
  mounted() {
    this.obterSelectIntegrador();
  },
  methods: {
    startVSelect() {
      if (
        !this.$route.params.id &&
        !this.configuracaoPagamento &&
        !this.configuracaoPagamento.integradoraPagamentoId
      ) {
        console.log("[startVSelect] Valores Null ");
        return;
      }
      console.log("Options: ", this.integradorSelect.options);
      let index = this.integradorSelect.options.findIndex(
        (x) => x.id == this.configuracaoPagamento.integradoraPagamentoId
      );

      console.log("Index: ", index);
      if (index >= 0) {
        this.integradorSelect.itemSelected = this.integradorSelect.options[
          index
        ];
      }
    },
    validateForm(e) {
      e.preventDefault();
      if (
        !this.integradorSelect.itemSelected &&
        !this.integradorSelect.itemSelected.id
      ) {
        this.$notify({
          data: [
            "Atenção preencha os campos corretamente, Selecione uma integradora."
          ],
          type: "warn",
          duration: 5000
        });
        return;
      }

      if (this.configuracaoPagamento.id) {
        this.editar();
      } else {
        this.novo();
      }
    },
    novo() {
      this.configuracaoPagamento.id = this.$store.state.emptyGuid;
      this.loading = true;
      this.configuracaoPagamento.contaId = this.$store.getters.getContaId;
      this.configuracaoPagamento.integradoraPagamentoId = this.integradorSelect.itemSelected.id;

      console.log("novo: ", this.configuracaoPagamento);
      this.$http({
        url: "parametro-pagamento/adicionar",
        data: this.configuracaoPagamento,
        method: "POST"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/configuracao-pagamento");
          this.$notify({
            data: ["Configuração cadastrada com sucesso."],
            type: "success",
            duration: 10000
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    editar() {
      this.loading = true;
      this.configuracaoPagamento.contaId = this.$store.getters.getContaId;
      this.configuracaoPagamento.integradoraPagamentoId = this.integradorSelect.itemSelected.id;

      this.$http({
        url: "parametro-pagamento/editar",
        data: this.configuracaoPagamento,
        method: "POST"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/configuracao-pagamento");
          this.$notify({
            data: ["Configuração editada com sucesso."],
            type: "success",
            duration: 10000
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    obterConfiguracaoPagamento(id) {
      if (!id) return;

      this.$http({
        url: "parametro-pagamento/obter/" + id,
        method: "GET"
      })
        .then((resp) => {
          this.configuracaoPagamento = resp.data;
          console.log(
            "ObterConfiguraçãoPagamento: ",
            this.configuracaoPagamento
          );
          this.obterSelectIntegrador();
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    obterSelectIntegrador() {
      this.$http({
        url: "pagamento/obter-select2-integradora",
        method: "GET"
      })
        .then((resp) => {
          this.integradorSelect.options = resp.data;
          this.startVSelect();
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
